<template>
  <div class="tipalertbox">
    <el-alert
      :closable="false"
      :title="title"
      type="warning"
      class="tipalert"
      show-icon
      :description="content"
    >
    </el-alert>
  </div>
</template>

<script>
export default {
  props: ["cplbKEY"],
  data() {
    return {
      title: "",
      content: ""
    };
  },
  created() {
    this.tipContent();
  },
  methods: {
    tipContent() {
      switch (this.cplbKEY) {
        case this.$cplb.danye: //专版单页
          this.title = "1000张以上合适";
          this.content = "数量较少，请对比数码单张价格";
          break;
        case this.$cplb.smdy: //数码单页
          this.title = "500张以下合适";
          this.content = "数量较多，请对比胶印单张价格";
          break;
        default:
          this.text = "";
          this.content = "";
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tipalertbox {
  .tipalert {
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/chanpin/components/tipalert.vue